import React from 'react'
import PropTypes from 'prop-types'
import { Column, Columns } from '@resurs/midas-react'
import styles from '../chat.style'
import { ChatBubble } from './ChatBubble'
import { ChatPenStateBubble } from './ChatPenStateBubble'

const scrollToBottom = div => {
  if (div) {
    const isScrolledToBottom =
      div.scrollHeight - div.clientHeight <= div.scrollTop + 1
    if (!isScrolledToBottom) {
      // eslint-disable-next-line no-param-reassign
      div.scrollTop = div.scrollHeight - div.clientHeight
    }
  }
}

const messageId = message => `${message.text}-${message.timestamp}`

export const ChatHistory = ({ history }) => {
  const buildColumns = () => {
    const cols = []
    history.forEach(message => {
      if (message.fromMe) {
        cols.push(<Column key={`left${messageId(message)}`} col1 />)
      }
      if (message.isPenState) {
        cols.push(
          <Column key={`main${messageId(message)}`} col11>
            <ChatPenStateBubble />
          </Column>,
        )
      } else {
        cols.push(
          <Column key={`main${messageId(message)}`} col11>
            <ChatBubble
              text={message.text}
              fromMe={message.fromMe}
              timeStamp={message.timeStamp}
            />
          </Column>,
        )
      }
      if (!message.fromMe) {
        cols.push(<Column key={`right${messageId(message)}`} col1 />)
      }
    })
    return cols
  }

  return (
    <div style={styles.historyContainer} ref={div => scrollToBottom(div)}>
      <Columns>{buildColumns()}</Columns>
    </div>
  )
}

ChatHistory.propTypes = {
  history: PropTypes.array.isRequired,
}
